import React, { PropTypes, Component } from 'react';
import { connectToStores } from 'fluxible/addons';
import Products from '../components/Products';

class ProductPage extends Component {
  static propTypes = {
    products: PropTypes.array.isRequired
  }

  static defaultProps = {
    products: []
  }

  render() {
    var products = this.props.products;
    return (
      <Products entities={ products } />
      );
  }
}

ProductPage = connectToStores(ProductPage, ['ProductStore'], (stores, props) => {
  return {
    products: stores.ProductStore.get()
  };
});

export default ProductPage;


// WEBPACK FOOTER //
// ./src/pages/ProductPage.js